import React from 'react';

const TorontoHeading = () => (
  <div className="toronto-job-details">
    <div className="toronto-job-details__container">
      <h2> Job details </h2>
      <div className="toronto-job-details__content">
        <p>
          We are looking for safe, reliable Toronto drivers, 21 years or older, to drive on major ridesharing platforms
          like Uber. No professional driving experience is needed; free training is provided. Rent a car with Autzu
          where the hourly rate includes full maintenance, insurance, 24/7 customer support and roadside assistance.
        </p>
        <p>
          Autzu cars are regularly cleaned and inspected for the best driving experience. Our top drivers earn over
          $1000 a week, averaging $15-20 per hour. Great for those who need flexible income such as students,
          entrepreneurs and creatives. Work when you want, where you want.
        </p>
      </div>
    </div>
  </div>
);

export default TorontoHeading;



// WEBPACK FOOTER //
// ./src/components/Static/UberToronto/JobDetails.js